var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 184 255.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.42,233c1.24,12.6,11.87,22.44,24.79,22.44s23.55-9.84,24.79-22.44h-49.58Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M117,37C115.76,16.23,105.13,0,92.21,0s-23.55,16.23-24.79,37h49.58Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M172,183v-88.27c0-37.41-30.33-67.73-67.73-67.73h-21.53c-37.41,0-67.73,30.33-67.73,67.73v88.27H0v45h184v-45h-12ZM16,225v-34h13c-.2-30.22-.41-60.43-.61-90.65,0-34.99,25.04-63.35,55.94-63.35h17.78c30.89,0,55.94,28.36,55.94,63.35-.02,29.88-.03,59.76-.05,89.65h9c.32,11.67.64,23.33.96,35H16Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bell-icon.2e4543e57a7e0f0c92cbe339c8746332.svg";
export { ForwardRef as ReactComponent };